import React, { useState } from "react";
import { Container, Image } from "react-bootstrap";

import { Layout } from "../../components/layout";
import { ProjectItemsGroup } from "../../components/project-items-group";

import styles from "./main.module.scss";

export interface MainProps {}

export function Main(props: MainProps) {
  const [solutionItems, setSolutionItems] = useState([
    {
      title: "测评交付",
      description:
        "我们以提供全球认证测试而自豪，与国际权威机构密切合作，确保我们的测试符合全球标准。我们卓越的声誉反映在我们赢得了世界各地认证机构的信任和尊重。我们为众多部门和行业提供测试，确保我们的客户获得必要的认证，以扩大他们的视野。我们的专业监考团队是我们的核心资产之一，体现了我们在管理考试方面保持最高诚信的承诺。我们的监考人员经过全面的培训，以确保所有的测试都以最高的专业精神和遵守道德标准进行。他们擅长管理现场和远程考试，确保为所有考生提供无缝和安全的考试体验。",
      image: "/solutions/exam.png"
    },
    {
      title: "全球交付",
      description:
        "为国教育与全球头部评估公司合作，在全球范围为考生提供国际认证解决方案，释放国际认证、针对性培训和人才获取的潜力。我们专业考务团队也可为全球认证提供测评交付，实现他们的认证计划。认证允许学习者获得劳动力准备技能。个人在完成学业后为就业做好准备，并拥有雇主想要的技能。对于专注于职业发展的成人学习者来说，证书课程的学习非常重要。雇主看重那些主动寻找机会发展自己技能和专业知识的专业人士。职业成长，国际标准认证是为国教育一直的追求！",
      image: "/solutions/global.png"
    },
    {
      title: "测试交付",
      description:
        "为国教育提供基于计算机和基于纸张的测试交付方法，以适应个人和组织的特定需求。基于计算机的考试交付: 我们以计算机为基础的考试允许考生使用配备专业软件和安全考试系统的计算机参加考试，具备灵活、即时、安全、有效等优点。除了计算机考试外，我们还为某些考试提供纸考。由于特定的需求或基础设施的限制，在某些环境或地区，基于纸张的测试仍然是首选。我们了解提供满足不同偏好和情况的考试交付选择的重要性。无论是基于计算机还是基于纸张的测试，我们都努力提供可靠和安全的测试体验，坚持国际标准和最佳实践。",
      image: "/solutions/test.png"
    }
  ]);

  return (
    <Layout>
      <Image
        src="/solutions/intro-background.jpg"
        width={"100%"}
        height={340}
        className="object-fit-cover"
      />

      <Container>
        <h2 className={styles.title}>
          我们的解决方案：提供适合您业务需求的正确解决方案
        </h2>
        <p className={styles.subtitle}>
          我们相信，通过我们所有人的学习、评估和提升方式的进步，我们可以改善生活，积极地影响世界，让世界变得更美好。无论您是进行评估还是交付，我们都致力于支持您的旅程
        </p>
        <ProjectItemsGroup
          imagePositionStrategy="firstRight"
          items={solutionItems}
        />
      </Container>
    </Layout>
  );
}
